<template>
  <div>
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      机构角色<span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>
    </div>
    <form class="class_add_con w622 col_2_1 " data-vv-scope="form" style="width: 944px;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0" class="page_edit_table">
        <tr class="tita">
          <td colspan="2" align="left" class="left_td" style="text-align:left;">机构角色基本信息</td>
        </tr>
        <!--div class="error_msg">{{ errors.first('form.value') }}</div-->
        <tr>
          <td align="center"  class="t_left3">角色名称：</td>
          <td><input name="" type="text" class="put_txt w200" v-model="form.name" /><span>*</span></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">英文名称：</td>
          <td><input name="" type="text" class="put_txt w200" v-model="form.nameEn" /><span>*</span></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">角色类型：</td>
          <td><select v-model="form.type">
            <option value="3">游客</option>
            <option value="2">管理员</option>
          </select><i>"管理员"拥有进入后台权限</i></td>
        </tr>
        <tr>
          <td align="center"  class="t_left3">角色授权：</td>
          <td>
            <!--div style="height: 250px; overflow: scroll;"-->
            <TreeSelect v-if="flag" :data="menus" :selected="selected" style="width: 550px;"></TreeSelect>
            <!--/div-->
          </td>
        </tr>
        <tr>
          <td class="t_left2">&nbsp;</td>
          <td align="left"  class="t_left2">
            <input name="" type="button" class="put_btn" value="确认提交" @click="validateForm('form')" />　
            <!--input name="" class="put_btn" type="button" value="重填" /-->
          </td>
        </tr>
      </table>
    </form>
    <div class="clear"></div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import Bus from '@/utils/bus'
  import TreeSelect from '@/page/byl/sys/role/treemenu.vue'
  import clonedeep from 'lodash.clonedeep'
  import difference from 'lodash.differenceby'
  export default {
    components: { TreeSelect },
    data () {
      return {
        form: {
          type: '2',
          isSystem: '1'
        },
        menus: [],
        selected: [],
        flag: false,
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      this.getMenus({isShow: '1'}).then((r) => { // 只取菜单
        this.menus = r
        if (!this.isEdit) { // 新增时全部勾中
          // this.setTreeStatus(this.menus) // 设置ui上的选中效果
          this.selected = this.menus
          this.flag = true
        } else {
          this.getMenusByRole({isShow: '1', roleId: this.$route.params.id}).then((r) => {
            // this.setTreeStatus2(r, this.menus) // 设置ui上的选中效果
            this.selected = r
            this.flag = true
          })
        }
        if (this.isEdit) {
          this.getModel(this.$route.params.id).then((r) => {
            this.form = r
          })
        }
      })
    },
    mounted () {
      var that = this
      Bus.$on('selected-menu', function (data) { // 选中的菜单项目
        that.selected = data
        // console.log(that.selected)
      })
    },
    computed: {
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'void'
      }
    },
    methods: {
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            api.post(config.bylBaseCenterPath, '/menu/listByRole', {isShow: '0'}, (r) => {
              let a = bus.$utils.flattern(r.data) // 设置好的接口拼上去
              let result = a.concat(bus.selected)
              bus.form.menuList = bus.set2Back(result) // 给selected分配menuId
              // console.log(bus.form.menuList)
            })
            bus.confirmBox({
              yes: function () {
                api.post(config.bylBaseCenterPath, '/role/edit', bus.form, function (r) { // 正常
                  if (bus.isEdit) { // 编辑
                    bus.popup('保存成功')
                  } else {
                    bus.popup('创建角色成功')
                  }
                  bus.$router.push(bus.prefix + '/org/orgroleList')
                })
              }
            })
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      to (path) {
        this.$router.push(path)
      },
      getModel (id) {
        var that = this
        return new Promise(function (resolve, reject) {
          api.get(config.bylBaseCenterPath, '/role/'  + id, null, function (r) { // 正常
            resolve(r.data)
          })
        })
      },
      getMenus (filters) {
        if (!filters) { filters = {} }
        var that = this
        return new Promise(function (resolve, reject) {
          api.post(config.bylBaseCenterPath, '/menu/listByRole', filters, function (r) { // 正常
            resolve(r.data)
          })
        })
      },
      getMenusByRole (filters) {
        if (!filters) { filters = {} }
        var that = this
        return new Promise(function (resolve, reject) {
          api.post(config.bylBaseCenterPath, '/menu/menuByRole', filters, function (r) { // 正常
            resolve(r.data)
          })
        })
      },
      setTreeStatus (arr) {
        var that = this
        for (let j = 0; j < arr.length; j++) {
          var m = arr[j]
          if (m.checked == false) {
            m.checked = true
          }
          if (!m.checked) { // !!!
            that.$set(m, 'checked', true)
          }
          var _setC = function (o) {
            if (o) {
              for (let j = 0; j < o.length; j++) {
                if (o[j].checked == false) {
                  o[j].checked = true
                }
                if (!o[j].checked) {
                  that.$set(o[j], 'checked', true)
                }
                _setC(o[j].children)
              }
            }
          }
          _setC(m.children)
        }
        return arr
      },
      setTreeStatus2 (arr1, arr2) {
        /* arr1: 选中的菜单 arr2: 所有菜单 */
        var that = this
        if (arr1 && arr1.length > 0) {
          let _setC1 = function(arr) {
            for (let i = 0; i < arr.length; i++) {
              var menu1 = arr[i]
              if (menu1.children) {
                _setC1(menu1.children)
              }
              let _setC2 = function (arr) {
                for (let i = 0; i < arr.length; i++) {
                  var menu2 = arr[i]
                  if (menu1.id == menu2.id) {
                    if (menu2.checked == false) {
                      menu2.checked = true
                    }
                    if (!menu2.checked) {
                      that.$set(menu2, 'checked', true)
                    }
                  }
                  if (menu2.children) {
                    _setC2(menu2.children)
                  }
                }
              }
              _setC2(arr2)
            }
          }
          _setC1(arr1)
        }
      },
      set2Back (arr) {
        var r = []
        for (let i = 0; i < arr.length; i++) {
          let o = {}
          let menu = arr[i]
          o.menuId = menu.id
          o.menuName = menu.name
          r.push(o)
        }
        return r
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/byl/org/role/model.vue